import LoginImage from "../../assets/Login/img-1.svg";
import LoginImage2 from "../../assets/Login/img-2 1.svg";
import theme from "../../theme/theme";
import color from "../../constants/color";

const styles = {
  gridContainer: {
    alignItems: "center",
  },
  main: {
    backgroundColor: "#F1F1F1",
    py: { xs: 4, sm: 4, md: 6, lg: 0 },
    height: { xs: "auto", sm: "auto", md: "100vh" },
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
  },
  paper: {
    borderRadius: 10,
    overflow: "hidden",
    boxShadow: "none",
    border: "1px solid #DEDEDE",
  },
  formContain: {
    backgroundColor: "#fff",
    padding: theme.spacing(4),
    [theme.breakpoints.up("sm")]: {
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(5),
    },
    [theme.breakpoints.up("lg")]: {
      paddingLeft: theme.spacing(9),
      paddingRight: theme.spacing(9),
    },
  },
  headingborder: {
    width: "20%",
    borderBottom: "3px solid #000",
    mb: 4,
  },
  mainheading: {
    mb: 1,
    fontWeight: 600,
    fontSize: "26px",
    color: "#202020",
  },
  descriptionText: {
    fontSize: "14px",
    fontWeight: "400",
    color: "#878787",
    mb: 3,
    lineHeight: "1.5",
  },
  inputText: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#202020",
    mb: 1,
  },
  submit: {
    color: "white !important",
    borderRadius: 20,
    fontSize: "14px",
    fontWeight: "500",
    textTransform: "none",
    mt: 2,
    mb: 2,
    py: 1.5,
    backgroundColor: "#000",
    " & .css-1yt7yx7-MuiLoadingButton-loadingIndicator": {
      position: "unset",
    },
    "& .MuiButton-startIcon": {
      marginRight: "8px",
      marginLeft: "-8px",
    },
    "&:disabled": {
      backgroundColor: "#cccccc",
      color: "#ffffff",
    },
  },
  gridItem: {
    padding: theme.spacing(4),
    backgroundColor: "#fff",
    borderRight: "1px solid #DEDEDE",
    [theme.breakpoints.up("sm")]: {
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(5),
    },
    [theme.breakpoints.up("lg")]: {
      paddingLeft: theme.spacing(9),
      paddingRight: theme.spacing(9),
    },
  },
  root: {
    px: 0,
  },
  image: {
    px: { xs: 3, sm: 5, lg: 8 },
    justifyContent: "center",
    alignItems: "center",
    py: "6%",
    "& . css-1m9128y": {
      position: "absolute",
      bottom: 4,
    },
  },
  backgroundImage: {
    backgroundImage: `url("${LoginImage}")`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    height: "300px",
    width: "100%",
  },
  backgroundImage2: {
    backgroundImage: `url("${LoginImage2}")`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    height: "300px",
    width: "100%",
  },
  sliderText: {
    my: "8%",
    px: 5,
    textAlign: "center",
    fontWeight: "500",
    fontSize: "12px",
    color: "#202020",
  },
  dots: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    ml: "50%",
    mb: 3,
  },
  dot1: {
    width: "3%",
    height: "5px",
    backgroundColor: "#202020",
    borderRadius: "30px",
    mx: "1%",
  },
  dot2: {
    width: "5px",
    height: "5px",
    backgroundColor: "#202020",
    borderRadius: "30px",
  },
  imageContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    padding: theme.spacing(4),
  },
};

export default styles;
